module.exports = __webpack_public_path__ + "static/media/ic_share_my_location.f62e5382.svg";